
<div>
  <label :for="$attrs.id" class="a-select-label"><slot></slot></label>
  <a-select
    :id="$attrs.id"
    :options="options"
    :selectedOptionIds="assigneeIds"
    bind-by-object
    :multiselect="true"
    compress
    @input="createAssignee"
    @destroy="destroyAssignee"></a-select>

  <template v-for="permittee in permittees">
    <pill :class="tagClasses(permittee)" full
          @onRemove="permittee.destroy()"
          :value="permittee.display"
    >
      <template #suffix v-if="permittee.legacyConfigTooltip">
        <button type="button" class="btn-icon" v-tooltip="permittee.legacyConfigTooltip">
          <icon class="exclamation"></icon>
          <span class="sr-only">{{ permittee.legacyConfigTooltip }}</span>
        </button>
      </template>
    </pill>
  </template>
</div>
